import { useContext, useEffect } from 'react'
import { Location } from 'history'
import { ChildData } from 'react-router-navigation-prompt'

import { registerNavigationPromptContext, unregisterNavigationPromptContext } from './NavigationPromptProvider'

interface ExtraHandlers {
  saveBeforeNavigate?: () => Promise<void>
  deleteBeforeNavigate?: () => Promise<void>
}

interface NavigationPromptProps extends ExtraHandlers {
  component: React.ComponentType<ChildData & ExtraHandlers>
  name: string
  when: (currentLocation: Location, nextLocation?: Location) => boolean
}

export function NavigationPrompt({ component, name, when, saveBeforeNavigate, deleteBeforeNavigate }: NavigationPromptProps) {
  const registerNavigationPrompt = useContext(registerNavigationPromptContext)
  const unregisterNavigationPrompt = useContext(unregisterNavigationPromptContext)

  useEffect(() => {
    registerNavigationPrompt(name, {
      component,
      when,
      saveBeforeNavigate,
      deleteBeforeNavigate
    })
    return () => {
      unregisterNavigationPrompt(name)
    }
  }, [component, name, when, saveBeforeNavigate, deleteBeforeNavigate])

  return null
}
